module.exports = __webpack_public_path__ + "static/media/magnet-score.408c9a01.svg";